import { useRef } from "react";
import Avatar from "@/components/Avatar";
import { Camera, X } from "lucide-react";

export default function CoachPhotoInput({ value, name, onChange, testId = "coach-photo-input" }) {
  const ref = useRef(null);

  const pick = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const s = Math.min(img.width, img.height);
        canvas.width = 256; canvas.height = 256;
        canvas.getContext("2d").drawImage(img, (img.width - s) / 2, (img.height - s) / 2, s, s, 0, 0, 256, 256);
        onChange(canvas.toDataURL("image/jpeg", 0.85));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
    e.target.value = "";
  };

  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <Avatar src={value || null} name={name || "?"} size={52} />
      <button type="button" data-testid={`${testId}-btn`} onClick={() => ref.current?.click()}
        className="flex items-center gap-1.5 border border-pb-border text-zinc-300 hover:border-pb-cyan hover:text-pb-cyan text-[10px] font-bold uppercase tracking-widest px-3 py-2 transition-colors">
        <Camera className="w-3.5 h-3.5" /> {value ? "Change Photo" : "Upload Photo"}
      </button>
      {value && (
        <button type="button" data-testid={`${testId}-remove`} onClick={() => onChange("")}
          className="flex items-center gap-1 text-zinc-500 hover:text-red-400 text-[10px] uppercase tracking-widest transition-colors">
          <X className="w-3 h-3" /> Remove
        </button>
      )}
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} />
    </div>
  );
}
